import { ReusableFunctions } from './reusable-functions';
import { Router } from '@angular/router';
import * as Highcharts from 'highcharts';

export class PipelineLockStatusChartOptions {
    constructor(private router: Router, private reusableFunctions: ReusableFunctions) {}

    getLockStatusByMilestoneOptions(
        charttitle: string,
        xAxisText: string,
        yAxisText: string,
        processedSeriesData: any,
        route: string,
        urlSegment: string,
        showLegend: boolean,
        hasDrilldownAccess: boolean,
        isAxisClickable,
        navFromUrl: string
    ): Highcharts.Options {
        const _this = this;
        let chartOpt: Highcharts.Options = {
            chart: {
                spacingTop: 0,
                events: {
                    render: function () {
                        if (isAxisClickable) {
                            var xAxis = this.xAxis[0];
                            var xTicks = xAxis.ticks;
                            let tickKeys = Object.keys(xTicks);
                            let points: Highcharts.Point[] = [];
                            this.series.forEach((series) => {
                                points = points.concat(series.points);
                            });
                            try {
                                tickKeys.forEach((key, i) => {
                                    let xTick = xTicks[key];
                                    if (xTick && xTick.label) {
                                        let pointInf = points.find((point) => {
                                            return (
                                                point.name &&
                                                xTick.label.element.textContent &&
                                                point.name.toLowerCase().trim() ===
                                                    xTick.label.element.textContent
                                                        .toLowerCase()
                                                        .trim()
                                            );
                                        });

                                        var label = xTick.label.element;
                                        label.style.cursor = 'pointer';
                                        label.onclick = function (item) {
                                            let queryParams = {
                                                titleSuffix: ': ' + (pointInf ? pointInf.name : ''),
                                                closerId: pointInf ? pointInf.properties.empId : '',
                                                loanLockStatus: 'All',
                                                navFromUrl: navFromUrl,
                                            };

                                            if (urlSegment === 'insights_lockStatusByMilestone') {
                                                queryParams['loanCategory'] = 'All';
                                                queryParams['activeMilestones'] =
                                                    pointInf.properties.activeMilestones;
                                            } else if (
                                                urlSegment === 'insights_lockStatusByLoanType'
                                            ) {
                                                queryParams['loanCategory'] =
                                                    pointInf.properties.loanType;
                                                queryParams['activeMilestones'] = 'All';
                                            }
                                            _this.router.navigate([route, urlSegment], {
                                                queryParams: queryParams,
                                            });
                                        };
                                    }
                                });
                            } catch (error) {
                                throw error;
                            }
                        }
                    },
                },
            },
            title: {
                text: charttitle,
                align: 'left',
                style: {
                    fontSize: '27px',
                    color: '#223540',
                    fontFamily: 'Roboto',
                },
            },
            credits: {
                enabled: false,
            },
            series: processedSeriesData,
            exporting: {
                enabled: false,
                buttons: {
                    contextButton: {},
                },
            },
            xAxis: [
                {
                    type: 'category',
                    tickInterval: 1,
                    startOnTick: false,
                    pointIntervalUnit: xAxisText,
                    labels: {
                        enabled: true,
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },
                    title: {
                        text: xAxisText,
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },
                } as Highcharts.XAxisOptions,
            ],
            yAxis: [
                {
                    title: {
                        text: yAxisText,
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },

                    labels: {
                        enabled: true,
                        style: {
                            fontSize: '10px',
                            color: '#666666',
                        },
                    },
                    lineWidth: 1,
                } as Highcharts.YAxisOptions,
            ],
            legend: {
                enabled: showLegend,
                align: 'left',
                verticalAlign: 'top',
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    minPointLength: 3,
                    states: {
                        hover: {
                            brightness: -0.3,
                        },
                    },
                },
                bar: {
                    stacking: 'normal',
                    minPointLength: 3,
                    states: {
                        hover: {
                            brightness: -0.3,
                        },
                    },
                },
                series: {
                    groupPadding: 0,
                    lineWidth: 3,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0,
                    dataGrouping: {
                        enabled: false,
                    },
                    maxPointWidth: 50,
                    marker: {
                        enabled: false,
                        states: {
                            hover: {
                                radius: 4,
                                enabled: true,
                                radiusPlus: 0,
                                lineWidthPlus: 0,
                                lineWidth: 0,
                            },
                        },
                    },
                    point: {
                        events: {
                            click: function (event) {
                                let point = event.point;
                                if (hasDrilldownAccess && point) {
                                    _this.navigateTo(
                                        route,
                                        urlSegment,
                                        point.properties.loanType,
                                        point.properties.lockStatus,
                                        point.properties.activeMilestones,
                                        navFromUrl,
                                        'All'
                                    );
                                }
                            },
                        },
                    },
                    cursor: hasDrilldownAccess ? 'pointer' : 'default',
                } as Highcharts.PlotSeriesOptions,
            },
            tooltip: {
                style: {
                    color: '#223540',
                    fontFamily: 'Roboto',
                    fontSize: '12',
                    height: 12,
                    opacity: 1,
                },
                borderColor: '#223540',
                backgroundColor: 'white',
                borderRadius: 6,
                useHTML: true,
                shared: true,
                followPointer: true,
                distance: 15,

                formatter: function () {
                    let tooltip = '';
                    if (showLegend) {
                        let length = this.points.length;
                        let thisPeriodTotal = 0;
                        let thisPeriodUnitTotal = 0;

                        tooltip =
                            '<table style="border-collapse: collapse">' +
                            this.points.reduce(function (s, point, index) {
                                let toolText = '';
                                let value = _this.reusableFunctions.formatMoney(
                                    point.point.properties.volume
                                );
                                let seriesName = point.series.name;
                                if (index === 0) {
                                    s =
                                        s +
                                        '<td colSpan="4" style="text-align: left;"><b>' +
                                        point.point.name.toUpperCase() +
                                        '<b></td></tr>';
                                }

                                thisPeriodUnitTotal += point.point.properties.units;
                                thisPeriodTotal += point.point.properties.volume;
                                toolText =
                                    s +
                                    '<tr style="line-height: 16px;"><td class="tooltip-data-title" ' +
                                    'style="color: ' +
                                    point.point.color +
                                    '"><b>' +
                                    seriesName +
                                    '</b></td><td style="text-align: right"> ' +
                                    value +
                                    '</td>' +
                                    '<td style="padding: 0 5px 0 5px">/</td><td style="text-align: right;">' +
                                    point.point.properties.units.toLocaleString() +
                                    '</td>' +
                                    '</tr>';
                                if (index === length - 1) {
                                    toolText =
                                        toolText +
                                        '<tr style="border-top: 1px solid #b3b3b3; line-height: 16px;"><td><b>Total ' +
                                        '</b></td><td style="text-align: right;"><b>' +
                                        _this.reusableFunctions.formatMoney(thisPeriodTotal) +
                                        '</b></td>' +
                                        '<td style="padding: 0 5px 0 5px">/</td><td style="text-align: right;"><b>' +
                                        thisPeriodUnitTotal.toLocaleString() +
                                        '</b></td>' +
                                        '</tr>';
                                }

                                return toolText;
                            }, '<tr style="line-height: 18px; font-size: 14px">') +
                            '</table>';
                    }
                    return tooltip;
                },
            } as Highcharts.TooltipOptions,
            lang: {
                noData: 'There are no data results.',
            },
            noData: {
                style: {
                    fontWeight: 'bold',
                    fontSize: '15px',
                    color: '#303030',
                },
            },
        };

        return chartOpt;
    }

    getHeatmapOptions(
        seriesData,
        xCategories: string[],
        yCategories: string[],
        chartTitle: string,
        hasDrilldownAccess,
        route: string,
        urlSegment: string,
        navFromUrl: string
    ) {
        let _this = this;
        let heatMapOpt = {
            chart: {
                spacingTop: 0,
                events: {
                    load: function () {
                        if (hasDrilldownAccess) {
                            var xAxis = this.xAxis[0];
                            var xTicks = xAxis.ticks;
                            var yAxis = this.yAxis[0];
                            var yTicks = yAxis.ticks;
                            var points = this.series[0].points;
                            // TOTO: Reactivate this after drilldown sproc fix
                            //if (yTicks[0] && yTicks[0].axis && yTicks[0].axis.categories) {
                            //    yTicks[0].axis.categories.forEach((category, i) => {
                            //        if (yTicks[i]) {
                            //            var label = yTicks[i].label.element;
                            //            label.onclick = function () {
                            //                if (hasDrilldownAccess) {
                            //                    _this.navigateTo(
                            //                        route,
                            //                        urlSegment,
                            //                        'All',
                            //                        'All',
                            //                        category['name'],
                            //                        '999',
                            //                        'All'
                            //                    );
                            //                }
                            //            };
                            //        }
                            //    });
                            //}

                            points.forEach((pointInf, i) => {
                                let point = pointInf as Highcharts.PointOptionsObject;
                                if (xTicks[i]) {
                                    var label = xTicks[i].label.element;

                                    label.onclick = function (item) {
                                        if (hasDrilldownAccess) {
                                            _this.navigateTo(
                                                route,
                                                urlSegment,
                                                'All',
                                                'All',
                                                'All',
                                                navFromUrl,
                                                point.custom.daysToExpiration.toString(),
                                                point.name.toString()
                                            );
                                        }
                                    };
                                }
                            });
                        }
                    },
                },
            },

            title: {
                text: chartTitle,
                align: 'left',
                style: {
                    fontSize: '27px',
                    color: '#223540',
                    fontFamily: 'Roboto',
                },
            },

            xAxis: {
                categories: xCategories,
                style: {
                    fontSize: '10px',
                    color: '#666666',
                },
                labels: {
                    enabled: true,
                    style: {
                        cursor: hasDrilldownAccess ? 'pointer' : '',
                    },
                },
                scrollbar: {
                    enabled: true,
                    minWidth: 1000,
                },
            },

            yAxis: {
                categories: yCategories,
                title: null,
                reversed: true,
                style: {
                    fontSize: '10px',
                    color: '#666666',
                },
                labels: {
                    enabled: true,
                    style: {
                        // TOTO: Reactivate this after drilldown sproc fix
                        //cursor: hasDrilldownAccess ? 'pointer' : '',
                    },
                },
            },

            accessibility: {
                enabled: true,
                point: {},
            },

            colorAxis: {
                min: 0,
                minColor: '#FFFFFF',
                maxColor: '#B9BFFF',
            },

            legend: {
                enabled: true,
                align: 'right',
                layout: 'horizontal',
                margin: 0,
                verticalAlign: 'top',
                title: {
                    text: '# of Locks Expiring',
                    style: {
                        fontSize: '14px',
                        color: '#223540',
                        fontFamily: 'Roboto',
                        transform: 'translate(-135px, 28px)',
                    },
                },
                itemStyle: {
                    fontSize: '10px',
                    color: '#223540',
                    fontFamily: 'Roboto',
                },
                y: -24,
                symbolWidth: 250,
                width: 350,
                floating: true,
            },
            tooltip: {
                style: {
                    fontFamily: 'Roboto',
                    fontSize: '12',
                    height: 12,
                },
                borderRadius: 6,
                useHTML: true,
                formatter: function () {
                    let point = this.point as Highcharts.PointOptionsObject;
                    let volume = point.custom.volume ?? 0;
                    let tooltip =
                        '<table style="border-collapse: collapse">' +
                        '<tr style="line-height: 18px; font-size: 14px">' +
                        '<td colSpan="4" style="text-align: left;"><b>' +
                        this.series.yAxis.categories[point.y].toString().toUpperCase() +
                        '<b></td></tr>' +
                        '<tr style="line-height: 16px;"><td class="tooltip-data-title" ' +
                        'style="color: none; padding-right: 5px"><b>' +
                        this.series.xAxis.categories[point.x] +
                        '</b></td><td style="text-align: right"> ' +
                        '' +
                        _this.reusableFunctions.formatMoney(volume) +
                        '</td>' +
                        '<td style="padding: 0 5px 0 5px">/</td><td style="text-align: right;">' +
                        (point.value != null ? point.value.toLocaleString() : '0') +
                        '</td></tr></table>';
                    return tooltip;
                },
            },
            exporting: {
                enabled: false,
            },
            credits: {
                enabled: false,
            },
            series: [
                {
                    name: 'Milestones',
                    type: 'heatmap',
                    data: seriesData,
                    borderColor: '#ddd3ee',
                    borderWidth: 0.1,

                    dataLabels: {
                        enabled: true,
                        color: '#223540',
                        shadow: false,
                        inside: true,
                    },
                    cursor: hasDrilldownAccess ? 'pointer' : '',
                    point: {
                        events: {
                            click: function (event) {
                                let point = event.point as Highcharts.PointOptionsObject;
                                if (hasDrilldownAccess) {
                                    _this.navigateTo(
                                        route,
                                        urlSegment,
                                        'All',
                                        'All',
                                        point.custom.seriesName,
                                        navFromUrl,
                                        point.custom.daysToExpiration.toString(),
                                        point.name.toString()
                                    );
                                }
                            },
                        },
                    },
                },
            ],
        } as Highcharts.Options;
        return heatMapOpt;
    }

    navigateTo(
        route: string,
        urlSegment: string,
        loanCategory: string,
        lockStatus: string,
        status: string,
        navFromUrl: string,
        daysToExpiration = null,
        daysToExpirationLabel = 'All'
    ) {
        let titleSuffix =
            (loanCategory !== 'All' ? loanCategory + ' ' : '') +
            (status !== 'All' ? status + ' ' : '') +
            (lockStatus !== 'All' ? lockStatus + ' ' : '') +
            (daysToExpirationLabel !== 'All' ? daysToExpirationLabel + ' ' : '');
        let length = titleSuffix.length;
        if (titleSuffix.length > 0) {
            titleSuffix = ': ' + titleSuffix.slice(0, length - 1);
        }

        let queryParams = {
            loanCategory: loanCategory,
            loanLockStatus: lockStatus,
            activeMilestones: status,
            daysToExpiration: daysToExpiration,
            titleSuffix: titleSuffix,
            navFromUrl: navFromUrl,
        };

        this.router.navigate([route, urlSegment], {
            queryParams: queryParams,
        });
    }
}
